/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespAppliedFilters_user$ref = any;
type SbSharedRefineMenuDisplayPrefsSelect_user$ref = any;
type SbSharedRefineMenuFilters_user$ref = any;
export type SbRespRefineMenu_user$ref = any;
export type SbRespRefineMenu_user = {
    readonly " $fragmentRefs": SbRespAppliedFilters_user$ref & SbSharedRefineMenuFilters_user$ref & SbSharedRefineMenuDisplayPrefsSelect_user$ref;
    readonly " $refType": SbRespRefineMenu_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenu_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbRespAppliedFilters_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilters_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '74ebce40e67e74dec2659a58bcf480b0';
export default node;
